module.exports = __webpack_public_path__ + "img/maintop.1496ddc.png";